'use strict';
angular.module('far.token_users')
    .controller('tokenUsersController', function($log,$timeout,$http, FileUploader, tokenUsers, pagination, form, fileUploadFilters, showModalMessage, $uibModal) {
        var months=[
            {'id':1,'name':"Январь"},
            {'id':2,'name':"Февраль"},
            {'id':3,'name':"Март"},
             {'id':4,'name':"Апрель"},
            {'id':5,'name':"Май"},
            {'id':6,'name':"Июнь"},
             {'id':7,'name':"Июль"},
            {'id':8,'name':"Август"},
            {'id':9,'name':"Сентябрь"},
             {'id':10,'name':"Октябрь"},
            {'id':11,'name':"Ноябрь"},
            {'id':12,'name':"Декабрь"}
            ];

        var years=[
        {'id':1,'name':"2023"},
            {'id':2,'name':"2022"},
            {'id':3,'name':"2021"}
        ];
        var mountain=[
            {'id':1,'name':"Эльбрус"},
            {'id':2,'name':"Казбек"},
            
        ];
        var club=[];
        var clubs_all=[];
        var num


        var tokenusers=[];
	var vm = {
	    progress: true,
            submitted: false,
            show_error: false,
            tokenusers:{'items':[]},
            totalPages: 0,
            tokenUsersFilter: form('tokenUsersFilter'),
            startOffset: 0,
            tokenUsersFilterModel: {
                month: null,
                year: years[0],
                mountain: mountain[0]
            },
            getTokenUsers:getTokenUsers,
            form: {},
            token_users_show:[],
           
            submit: function () {
                vm.submitted = true;
                vm.show_error = true;

              

            },
            constructor: function (year,month) {
                console.log(month);
		      if (month!=null){

                for (var i in months){
                    if (months[i].id==parseInt(month))
                        vm.tokenUsersFilterModel.month=months[i];
                }
              }
              if (year!=null){

                for (var i in years){
                    if (parseInt(years[i].name)==parseInt(year))
                        vm.tokenUsersFilterModel.year=years[i];
                }
              }
           

                vm.getTokenUsers();
                
			
            }

                 };
        vm.tokenUsersFilter
            .addField('month', 'selectObject', {
                validators: {
                    required: true
                },
                options: {
                    ngChange: changeData,
                    class: 'form__item form__item_select'
                },
                ngOptions: 'item as item.name for item in field.items track by item.id',
                 label: null
            }, months)
            .addField('year', 'selectObject', {
                options: {
                    ngChange: changeData,
                    class: 'form__item form__item_select'
                },
                ngOptions: 'item as item.name for item in field.items track by item.id',
                label: null
            }, years)
            .addField('mountain', 'selectObject', {
                 ngOptions: 'item as item.name for item in field.items track by item.id',
               
                label: null,
                options: {
                    ngChange: changeData,
                    class: 'form__item form__item_select'
                }
            },  mountain)
            .addField('last_name', 'text', {
                label:null,
                options: {
                    ngChange: changeData,
                    placeholder: 'Фамилия'
                },
              
            })
            .addField('num', 'text', {
                label:null,
                options: {
                    ngChange: changeData,
                    placeholder: 'Номер'
                },
               
            })
            .addField('club', 'selectObject', {
                 ngOptions: 'item as item.name for item in field.items track by item.id',
               
                label: null,
                options: {
                    ngChange: changeData,
                    class: 'form__item form__item_select'
                }
            },  club);

        function changeData() {
            $timeout(function() {
            vm.getTokenUsers();
            });
            
        }
       
     function getFilters() {
                console.log('model',vm.tokenUsersFilterModel);
                console.log('fields',vm.tokenUsersFilter);

            return {
                num:  vm.tokenUsersFilterModel.num ?  vm.tokenUsersFilterModel.num : null,
                last_name:  vm.tokenUsersFilterModel.last_name ?  vm.tokenUsersFilterModel.last_name : null,
                mountain:  vm.tokenUsersFilterModel.mountain ?  vm.tokenUsersFilterModel.mountain.name : null,
                month: vm.tokenUsersFilterModel.month ? vm.tokenUsersFilterModel.month.name : null,
                year:vm.tokenUsersFilterModel.year ? vm.tokenUsersFilterModel.year.name : null,
                club:vm.tokenUsersFilterModel.club ? vm.tokenUsersFilterModel.club.name : null,

            }

        }
       
        function getTokenUsers() {
            return $http.get(Routing.generate('api_entities_get_token_users',
                angular.merge({}, getFilters())
            )).then(function(response) {
                var items = [];
                console.log('get_mountainroutes',response.data);
                angular.forEach(response.data, function(item) {
                    items.push(item);

                });


                console.log(items);
                vm.tokenusers.items=items;
                var data={};
                if (clubs_all.length==0){

                for (var i in vm.tokenusers.items)
                    if (vm.tokenusers.items[i].club) 
                        if (!(clubs_all.includes(vm.tokenusers.items[i].club)))
                                clubs_all.push(vm.tokenusers.items[i].club);    
                console.log('all_clubs',clubs_all);        
                for (var i in clubs_all)
                    club.push({"id":i,"name":clubs_all[i]});
                    
                }
                return items;
            }).catch(function(response) {
                $log.error(response);
                return $q.reject(response);
            })
        }

        return vm;
    });
